'use client'

import { useEffect, useState } from 'react'

export function LifeTimeSinceClientNumber({ date }: { date: string }) {
  const [mins, setMins] = useState(() => getMinutesSince(date))

  useEffect(() => {
    const update = () => setMins(getMinutesSince(date))
    const now = Date.now()
    const msToNextMinute = 60000 - (now % 60000)

    const timeout = setTimeout(() => {
      update()
      ;(cleanup as any).interval = setInterval(update, 60000)
    }, msToNextMinute)

    function cleanup() {
      clearTimeout(timeout)
      if ((cleanup as any).interval) clearInterval((cleanup as any).interval)
    }

    return cleanup
  }, [date])

  return <>{mins}</>
}

function getMinutesSince(date: string) {
  const published = new Date(date).getTime()
  const now = Date.now()
  return Math.max(0, Math.floor((now - published) / 60000))
}
